module.exports = __webpack_public_path__ + "static/media/UnpaidLeave.6018de75.svg";